import React from 'react'
import {
  Container,
  Row,
  Col,
  Table,
  Button
} from 'reactstrap'
import { ListItem } from '.'
import { IgtLoader } from 'Atoms'

const GitHubOrganizationAppsList = ({ modelList, isLoading }) => {
  return (
    <Container fluid>
      <Row>
        <Col lg={{ size: 6, offset: 3}}>
          <h1 className="text-center">GitHub Org Applications Table</h1>
        </Col>
        <Col lg="3">
          <Button href="/auth/create/github_organization_apps">Add New Application</Button>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          {
            isLoading ?
            <IgtLoader isLoading={isLoading}/>
            :
            <Table hover>
              <thead className='sticky-header'>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>App ID</th>
                  <th>Client ID</th>
                  <th>Team Selection?</th>
                  <th>Form Excluded?</th>
                  <th>Copilot Enabled?</th>
                  <th>Cost Center</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
                {
                  modelList && modelList.map((application, i) => {
                    return (
                      <ListItem
                        modelListItem={application}
                        key={i}
                        index={i}
                      />
                    )
                  })
                }
              </tbody>
            </Table>
          }
        </Col>
      </Row>
    </Container>
  )
}

export default GitHubOrganizationAppsList